import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Scroll suave y efectos interactivos
document.addEventListener('DOMContentLoaded', () => {
  // Navegación con scroll suave
  const navLinks = document.querySelectorAll('.nav-links a, .hero-buttons a, .option a');
  
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Solo procesar enlaces internos
      if (this.getAttribute('href').startsWith('#')) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80, // Ajustar por el header fijo
            behavior: 'smooth'
          });
          
          // Marcar el enlace activo
          navLinks.forEach(navLink => {
            navLink.classList.remove('active');
          });
          this.classList.add('active');
        }
      }
    });
  });

  // Efectos en las tarjetas de productos
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      // Añadir clase para efectos adicionales
      card.classList.add('hover');
    });
    
    card.addEventListener('mouseleave', () => {
      card.classList.remove('hover');
    });
    
    // Al hacer clic en la tarjeta (opcional)
    card.addEventListener('click', () => {
      // Aquí podrías agregar código para mostrar más detalles del producto
      // o redirigir a una página de producto específica
    });
  });

  // Formulario de suscripción
  const subscribeForm = document.querySelector('.subscribe-form');
  
  if (subscribeForm) {
    subscribeForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailInput = subscribeForm.querySelector('input[type="email"]');
      
      if (emailInput && emailInput.value) {
        // Aquí irían las validaciones y el envío del formulario
        alert('¡Gracias por suscribirte a nuestro newsletter!');
        emailInput.value = '';
      }
    });
  }

  // Efecto de resaltado para el elemento activo en la navegación según la posición del scroll
  function highlightNavOnScroll() {
    const sections = document.querySelectorAll('section[id]');
    const scrollPosition = window.scrollY + 100; // Ajuste para compensar la altura del header
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute('id');
      
      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        document.querySelector(`.nav-links a[href="#${sectionId}"]`)?.classList.add('active');
      } else {
        document.querySelector(`.nav-links a[href="#${sectionId}"]`)?.classList.remove('active');
      }
    });
  }
  
  window.addEventListener('scroll', highlightNavOnScroll);
  
  // Llamar a la función una vez al cargar la página
  highlightNavOnScroll();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
